// /src/renderer/shared/components/Slider/Slider.tsx
import React from "react";
// import "./Slider.scss";
import styles from './Slider.module.scss';

export interface SliderProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>,'onChange'> {
  id?: string;
  value: number;
  onChange: (event: number) => void;
  min?: number;
  max?: number;
  step?: number;
  className?: string;
}

function Slider({
  id,
  value,
  onChange,
  min = 0,
  max = 100,
  step = 1,
  className,
  ...rest
}: SliderProps): React.JSX.Element {
  const percentageString = (value:number) => `${((value - min) / (max - min)) * 100}%`;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.target.value);
    e.target.style.setProperty('--value-percent', percentageString(value));
    onChange(Number(e.target.value));
  };

  return (
    <div className={`${className?styles[className]:styles.container}`}>
      <input
        id={id}
        type="range"
        value={value}
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        style={{ '--value-percent': percentageString(value) } as React.CSSProperties}
        {...rest}
      />
      {/* <span className="slider-value">{value}</span> */}
    </div>
  );
}

export default Slider;
